document.addEventListener('DOMContentLoaded', () => {
    const showMoreButton = document.querySelector('.amenities-icons-banner__showmore');
    const amenities = document.querySelectorAll('.amenities-icons-banner__ameneitie');

    if (showMoreButton && amenities) {
        showMoreButton.addEventListener('click', (e) => {
            e.currentTarget.classList.toggle('amenities-icons-banner__showmore--show');
            e.currentTarget.ariaExpanded = e.currentTarget.ariaExpanded !== 'true';

            let i = 0;
            amenities.forEach((amenity) => {
                if (i >= 5) {
                    amenity.ariaHidden = amenity.ariaHidden !== 'true';
                }
                i++;
            });
        });

        /**
         * correct aria for media queries
         */
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        const resetAria = (mediaQuery) => {
            if (mediaQuery.matches) {
                showMoreButton.removeAttribute('aria-expanded');
                amenities.forEach((amenity) => {
                    amenity.removeAttribute('aria-hidden');
                });
            } else {
                showMoreButton.ariaExpanded = 'false';

                let i = 0;
                amenities.forEach((amenity) => {
                    if (i < 5) {
                        amenity.ariaHidden = 'false';
                    } else {
                        amenity.ariaHidden = 'true';
                    }
                    i++;
                });
            }
        };

        resetAria(mediaQuery);

        window.addEventListener('resize', () => {
            resetAria(mediaQuery);
        });
    }
});
